import { NgModule } from '@angular/core';
import { ModusCheckboxDirective } from './modus-checkbox.directive';

@NgModule({
  declarations: [ModusCheckboxDirective],
  exports: [ModusCheckboxDirective],
})
export class ModusCheckboxModule {}
